module.exports = __webpack_public_path__ + "static/ebr-3-7597638a14976288242722b7b4725204.jpg";